import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetTimeOffsByDateRange(startDate, endDate) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/user/timeoffs/date?from=${formatDate(startDate)}&to=${formatDate(endDate)}`,
    {
      onSuccess: (data) =>
        console.log(
          "Get all time offs by date range fetched successfully:",
          data?.data,
        ),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    },
  );
  const timeOffsByDateRange = data?.data;
  return {
    timeOffsByDateRange,
    error,
    mutate,
    isLoading,
  };
}
